import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81653c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font":"var(--main_16R)"} }, [
    /*#__PURE__*/_createTextVNode(" 안전한 조합원 자격 거래를 위해서 반드시"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"var(--title_16B)"} }, "본인 명의의 은행/증권계좌, 주소 정보"),
    /*#__PURE__*/_createTextVNode("가 필요해요!"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("정보 입력 및 확인 후 다음단계를 진행합니다. ")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 다음 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_personal_info = _resolveComponent("personal-info")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, { handle: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_modal_header, {
          title: "개인정보 확인",
          onClose: _cache[0] || (_cache[0] = () => _ctx.setOpen(false))
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoList, (info, idx) => {
            return (_openBlock(), _createBlock(_component_personal_info, {
              key: (info, idx),
              "info-type": info,
              "info-value": _ctx.infoValueList[idx]
            }, null, 8, ["info-type", "info-value"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, { pb: "safeAreaBottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          px: "20px",
          py: "16px",
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              block: "lg",
              corner: "10px",
              outline: "primary",
              width: "100%",
              onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              block: "lg",
              corner: "10px",
              disabled: _ctx.nextButton,
              width: "100%",
              onClickCapture: _ctx.nextProcess
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["disabled", "onClickCapture"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}